<template>
  <router-view />
</template>
<script>
	import { mapActions } from 'vuex';
	export default {
		components: {

		},
		computed: {
			isLoggedIn() {
		      return this.$store.state.isLoggedIn;
		    },
		    userName() {
		      return this.$store.state.name; 
		    }
		},
		mounted(){

		},
		created(){
			if (this.$store.state.isLoggedIn) {
		      this.$store.dispatch('retriveUserDetails', this.$router);
		    } else {
		    	 this.$store.dispatch('retriveUserDetails', this.$router);
		    }
		},
		methods: {
			...mapActions(['retriveUserDetails']),
			myTestMethod(){

			}
		}    
	}
</script>